import { useAuth } from '@/hooks/useAuth'
import { useAuthStore } from '@/stores/authStore'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

export function ImpersonationBanner() {
  const { user, isImpersonating } = useAuth()
  const { stopImpersonation } = useAuthStore()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  if (!isImpersonating) return null

  const handleExit = () => {
    stopImpersonation()
    queryClient.clear()
    navigate('/dashboard')
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-red-600 text-white text-center py-1 text-sm">
      <span className="font-medium">
        Impersonating {user?.email}
      </span>
      {' — '}
      <button onClick={handleExit} className="underline font-semibold hover:no-underline">
        Exit Impersonation
      </button>
    </div>
  )
}
